/**
 * Translation keys for the /full-body-mri-zurich SEO landing page.
 * Only city-specific copy lives here — all other sections compose
 * existing components that read from the `home`, `go`, `pricing`,
 * and `faq` namespaces.
 */
export const zurichMriKeys = {
  heroHeadline: "heroHeadline",
  heroBody: "heroBody",
  heroLocation: "heroLocation",
  heroCtaPrimary: "heroCtaPrimary",
  heroCtaSecondary: "heroCtaSecondary",
  clinicHeading: "clinicHeading",
  clinicBody: "clinicBody",
  clinicAddressLabel: "clinicAddressLabel",
  // City-flavored H2 overrides for sections that otherwise inherit
  // generic copy from the `go` namespace — picked up by the SEO audit
  // for the "full body MRI Zurich" search intent.
  pricingHeading: "pricingHeading",
  processHeading: "processHeading",
  expertsHeading: "expertsHeading",
  ctaHeading: "ctaHeading",
  ctaBody: "ctaBody",
} as const
